const ID = 'card';

export default ID;
